import * as z from "zod/v4";

export interface StreamChannelSchemaDefinition<TInput, TInitial, TEvent> {
  readonly inputSchema: z.ZodType<TInput>;
  readonly initialSchema: z.ZodType<TInitial>;
  readonly eventSchema: z.ZodType<TEvent>;
}

export function defineStreamChannelSchema<TInput, TInitial, TEvent>(
  definition: StreamChannelSchemaDefinition<TInput, TInitial, TEvent>,
): StreamChannelSchemaDefinition<TInput, TInitial, TEvent> {
  return definition;
}

export type AnyStreamChannelSchemaDefinition = StreamChannelSchemaDefinition<
  unknown,
  unknown,
  unknown
>;

export const teamNotificationsStreamInputSchema = z.object({
  visibility: z.enum(["public", "internal"]).default("internal"),
});
export type TeamNotificationsStreamInput = z.infer<
  typeof teamNotificationsStreamInputSchema
>;

export const userNotificationsStreamInputSchema = z.object({});
export type UserNotificationsStreamInput = z.infer<
  typeof userNotificationsStreamInputSchema
>;

export const teamNotificationsStreamChannelSchema = defineStreamChannelSchema({
  eventSchema: z.unknown(),
  initialSchema: z.unknown(),
  inputSchema: teamNotificationsStreamInputSchema,
});

export const userNotificationsStreamChannelSchema = defineStreamChannelSchema({
  eventSchema: z.unknown(),
  initialSchema: z.unknown(),
  inputSchema: userNotificationsStreamInputSchema,
});
